import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private userService: UserService, private router: Router) {}

  canActivate() {
    const token = this.auth.token;
    if (!token) {
      return this.router.parseUrl('/auth/login');
    }

    if (this.userService.currentUser) {
      return true;
    }

    return this.userService.loadMe().pipe(
      map(() => true),
      catchError(() => {
        this.auth.logout();
        this.userService.setUser(null);
        return of(this.router.parseUrl('/auth/login'));
      })
    );
  }
}
